// Components
import DatePicker from "vue2-datepicker";

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins.js";
import { dateMixins } from "@/app/mixins/utils/date-mixins";

// Services
import SubscriptionService from "@/app/services/main/subscription/subscription-service";
import { STATUS_CODES } from "@/app/constants/constants";

// Events
import EventBus from "@/app/bus/event-bus.js";

// Constants
import { SUBSCRIPTION_STATUS } from "@/app/constants/constants";

let preFilterData;
export default {
    name: "SubscriptionsManagementContainer",
    components: {
        DatePicker,
    },
    mixins: [tableMixins, toastMessageMixins, dateMixins],
    data() {
        const frequencyList = [
            {
                id: "P1M",
                name: "Monthly",
            },
            {
                id: "P3M",
                name: "Quarterly",
            },
            {
                id: "P12M",
                name: "Yearly",
            },
        ];

        const statusList = [
            {
                id: "A",
                name: "Active",
            },
            {
                id: "I",
                name: "Inactive",
            },
            {
                id: "CANCELLED",
                name: "Cancelled",
            },
            {
                id: "FOR_CANCELLATION",
                name: "For Cancellation",
            },
			{
                id: "ENDED",
                name: "Ended",
            },
        ];

        return {
            isAPILoading: false,
            isCreatingTracker: false,
            modifyMode: "",
            selectedOrder: {},
            // table
            theads: [
                {
                    name: "Subscription Name",
                    searchLabel: "f_subscriptionName",
                    sortLabel: "subscriptionName",
                    isDesc: false,
                    hasSearch: true,
                    style: null,
                },
                {
                    name: "Owner",
                    searchLabel: "f_owner",
                    sortLabel: "owner",
                    isDesc: false,
                    hasSearch: true,
                    style: "min-width: 150px",
                },
                {
                    name: "Owner Email",
                    searchLabel: "f_emailAddress",
                    sortLabel: "emailAddress",
                    isDesc: false,
                    hasSearch: true,
                    style: null,
                },
                {
                    name: "Pet",
                    searchLabel: "f_petName",
                    sortLabel: "petName",
                    isDesc: false,
                    hasSearch: true,
                    style: "min-width: 120px",
                },
                {
                    name: "Date Subscribed",
                    searchLabel: "f_createdAt",
                    sortLabel: "createdAt",
                    isDesc: false,
                    style: null,
                    hasSubscribedDatePicker: true,
                },
                {
                    name: "Expiry Date",
                    searchLabel: "f_subscriptionExpiry",
                    sortLabel: "subscriptionExpiry",
                    isDesc: false,
                    style: null,
                    hasExpiryDatePicker: true,
                },
                { 
					name: "Payment Method", 
					hasPaymentMethodFilter: true,
					searchLabel: "f_paymentMethod", 
					isDesc: false, 
					style: 'width: 170px' 
				},
                {
                    name: "Status",
                    searchLabel: "f_status",
                    sortLabel: "status",
                    isDesc: false,
                    hasSearchableDropdown: true,
                    optionList: statusList,
                    style: "min-width: 200px",
                },
            ],
            // sorting
            desc: true,
            sortBy: "id",
            // Date
            selectedSubscribedDate: "",
            selectedSubscribedExpiry: "",
            usersFilterData: "",
            filterValues:{},
            selectedPaymentMethod: '',
            paymentMethods: [
				{
					value: "Store credit",
					name: "Store Credit",
				},
				{
					value: "Stripe",
					name: "Credit Card",
				},
			],
        };
    },
    computed: {
        getFromUsersFilter() {
            return this.$store.getters.getFromUsersFilter;
        },
        isPreFilterMode() {
            return this.$store.getters.getSubscriptionPreFilterMode;
        },
    },
    async created() {
        await EventBus.$on("subscriptions", async (data) => {
            preFilterData = data;
            EventBus.$off("subscriptions");
        });
        this.setPreFilters();
        this.loadSavedFilters();
        this.getTableContent(false);
    },
    beforeDestroy() {
        this.$store.commit("clearFromUsersFilter");
        this.$store.commit("setSubscriptionPreFilterMode", false);
    },
    watch: {
        selectedSubscribedDate() {
            this.getTableContent(true);
        },
        selectedSubscribedExpiry() {
            this.getTableContent(true);
        },
    },
    activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
    methods: {
        onSubsFilter(filterBy, value) {
			if (filterBy) {
				this.page = 1;
				this.columnsFilter[filterBy] = value;
                this.filterValues[filterBy] = value;
				this.getTableContent(true, this.page, this.limit, this.sortBy, this.desc);
			}
		},
        onColumnSubsFilter(filterBy, event) {
			if (filterBy) {
				this.page = 1;
                this.columnsFilter[filterBy] = event.target.value;
                this.filterValues[filterBy] = event.target.value;
				this.delayTyping(() => {
					this.getTableContent(false, this.page, this.limit, this.sortBy, this.desc);
				});
			}
		},
        clearFilters() {
            const filters = this.$store.state.subscriptionFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0; 
            if (hasFilters) {
                this.$store.dispatch('resetFilters');
            }
        },
        clearFilterUI() {
            this.theads.forEach(th => {
                if (th.hasSearch) {
                  const searchInput = this.$refs[`filter_${th.sortLabel}`];
                  if (searchInput) {
                    searchInput.value = ''; 
                  }
                } else if (th.hasSearchableDropdown) {
                  const selectElement = this.$refs[th.inputId];
                  if (selectElement) {
                    selectElement.clear(); 
                  }
                } else if (th.hasSubscribedDatePicker) {
                  this.selectedSubscribedDate = null;
                } else if (th.hasExpiryDatePicker) {
                  this.selectedSubscribedExpiry = null;
                }
              });
        },
        saveAllFilters() {
            const filters = {};
                // Collect all the column filter values
                this.theads.forEach(th => {
                    if (th.hasSubscribedDatePicker) {
                        filters[th.sortLabel] = this.selectedSubscribedDate;
                    } else if (th.hasExpiryDatePicker) {
                        filters[th.sortLabel] = this.selectedSubscribedExpiry;
                    } else {
                        const searchInput = this.columnsFilter[`${th.searchLabel}`];
                        if (searchInput) {
                            filters[th.sortLabel] = searchInput;
                        }
                    }
                });

                // Add pagination details to filters
                filters.page = this.page; // current page
                filters.limit = this.limit; // items per page
                // Dispatch all filters, including pagination, to Vuex store
                Object.keys(filters).forEach(label => {
                    this.$store.dispatch('applyFilter', { label, value: filters[label] });
                });
          },          
          loadSavedFilters() {
            const filters = this.$store.state.subscriptionFilters.filters;
            const hasFilters = filters && Object.keys(filters).length > 0;
            if (hasFilters) {
                
                // You can access the saved filter values from the store like this:
                this.theads.forEach(th => {
                    const savedFilter = this.$store.getters.getFilter(th.sortLabel);

                    if (savedFilter) {
                        this.columnsFilter[th.searchLabel] = savedFilter;
                        if (th.hasSubscribedDatePicker) {
                            this.selectedSubscribedDate= savedFilter
                        } else if (th.hasExpiryDatePicker) {
                            this.selectedSubscribedExpiry = savedFilter
                        } else if(th.hasSearchableDropdown) {
                            // Find the option corresponding to the value
                            const option = th.optionList.find(option => option.id === savedFilter);
                            if (option) {
                                this.filterValues[th.searchLabel] = option// Dynamically set the value of v-select
                            }
                        } else {
                            this.filterValues[th.searchLabel] = savedFilter
                        }
                    }
                }); 

                this.page = this.$store.getters.getFilter('page') || 1;
                this.limit = this.$store.getters.getFilter('limit') || 10; 
        
                this.clearFilters()
            }
        },        
        setPreFilters() {
            if (this.isPreFilterMode) {
                const { emailAddress, petName } = this.getFromUsersFilter;
                this.columnsFilter["f_emailAddress"] = emailAddress;
                this.columnsFilter["f_petName"] = petName;
                this.$refs.filter_emailAddress[0].value = emailAddress;
                this.$refs.filter_petName[0].value = petName;
            }
        },
        getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
            this.getSubscriptionsList({ page, limit, sortBy, desc });
        },
        getSubscriptionsList(queryParams) {
            this.isAPILoading = true;
            if (this.columnsFilter) {
                const { f_subscriptionName, f_owner, f_emailAddress, f_petName, f_paymentFrequencyCode, f_status , f_paymentMethod } =
                    this.columnsFilter;

                if (f_subscriptionName) {
                    queryParams["f_subscriptionName"] = f_subscriptionName;
                }

                if (f_owner) {
                    queryParams["f_owner"] = f_owner;
                }

                if (f_emailAddress) {
                    queryParams["f_emailAddress"] = f_emailAddress;
                }

                if (f_petName) {
                    queryParams["f_petName"] = f_petName;
                }

                if (f_paymentFrequencyCode) {
                    queryParams["f_paymentFrequencyCode"] = f_paymentFrequencyCode;
                }

                if (f_status) {
                    queryParams["f_status"] = f_status;
                }

                if (f_paymentMethod) {
                    queryParams["f_paymentMethod"] = f_paymentMethod;
                }
            }

            if (this.selectedSubscribedDate) {
                queryParams["f_createdAt"] = this.formatDate(this.selectedSubscribedDate, "yyyy-MM-dd HH:mm");
            }

            if (this.selectedSubscribedExpiry) {
                queryParams["f_subscriptionExpiry"] = this.formatDate(
                    this.selectedSubscribedExpiry,
                    "yyyy-MM-dd HH:mm"
                );
            }

            SubscriptionService.getSubscriptionList(queryParams).then((res) => {
                if (res.status === STATUS_CODES.SUCCESS) {
                    this.tableContent = {
                        tableData: res.data.data,
                        paginationData: res.data.pagination,
                    };

                    if (this.isPreFilterMode) {
                        this.$store.commit("setSubscriptionPreFilterMode", false);
                    }
                } else {
                    const { ERROR_GET_SUBSCRIPTION_LIST } = this.toastMessages.subscription();

                    this.showAPIErrorToast(ERROR_GET_SUBSCRIPTION_LIST, res);
                }

                this.isAPILoading = false;
            });
        },

        viewSubscriptionDetails(subscriptionId) {
            this.$router.push(`subscriptions/details/${subscriptionId}`)
        },

        async preFilterSelected(type, sub) {
            let activeTab = "";
            this.saveAllFilters();

            if (type === "owner") {
                activeTab = "users";
            } else if (type === "petName") {
                activeTab = "pets";
                // const data = {
                //     emailAddress: sub.emailAddress,
                //     petName: sub.petName,
                //     owner: sub.owner,
                // }
                // await this.$store.commit("setOrdersPreFilterMode", true);
                // await this.$store.commit("setSubscriptionFilterData", data);
                // EventBus.$emit("orders", data);
            }

            if (type && sub) {
                this.$store.commit("setFromSubFilter", {
                    filter: sub.emailAddress,
                    activeTab,
                });
                if (type === "owner") {
                    this.$store.commit("setFromSubscription", true);
                    this.$router.push("/users");
                } else {
                    this.$router.push(`/orders/${sub.orderId}/view?actionFrom=user-subscription`);
                }
            }
        },
        getClassByStatus(status) {
            switch (status) {
                case SUBSCRIPTION_STATUS.FOR_CANCELLATION:
                    return "text-warning"
    
                case SUBSCRIPTION_STATUS.CANCELLED:
                case SUBSCRIPTION_STATUS.ENDED:
                    return "text-danger"

                case SUBSCRIPTION_STATUS.INACTIVE:
                case "I":
                    return "text-secondary"
                    
                default:
                    return "text-primary"
            }
        },
    },
};
